import StrengthIndicator from './StrengthIndicator'
export default StrengthIndicator
